// Importing the necessary types
import {
  IAnnouncementServiceResponse,
  IDashboardDetailsServiceResponse,
  IEmployeeDashboardPopUpServiceRepsonse,
  ITrainingVideosServiceResponse,
} from "../../../features/dashboard/types";
import ApiService from "../../ApiService";

enum DashboardEndpoints {
  DASHBOARD = "/employee/dashboard",
  TRAINING_VIDEOS = "/training-videos",
  DOCUMENTS = "/documents",
  POP_UP = "/employee/dashboard/popup",
}

// Define the DashboardService class that extends the ApiService class to interact with dashboard-related APIs
class DashboardService extends ApiService {
  // Method to fetch the dashboard details, including the active year as a query parameter
  async getDashboardDetails(
    activeYear: number
  ): Promise<IDashboardDetailsServiceResponse> {
    return this.get<IDashboardDetailsServiceResponse>(
      `${DashboardEndpoints.DASHBOARD}?active_year=${activeYear}`
    );
  }

  // Method to fetch the training video details
  async getTrainingVideo(): Promise<ITrainingVideosServiceResponse> {
    return this.get<ITrainingVideosServiceResponse>(
      DashboardEndpoints.TRAINING_VIDEOS
    );
  }

  // Method to fetch document types based on the provided document type
  async getDocumentTypes(
    documentType: string
  ): Promise<IAnnouncementServiceResponse> {
    return this.get<IAnnouncementServiceResponse>(
      `${DashboardEndpoints.DOCUMENTS}/${documentType}`
    );
  }

  async getDashboardPopUp(
    userId: number
  ): Promise<IEmployeeDashboardPopUpServiceRepsonse> {
    return this.post<IEmployeeDashboardPopUpServiceRepsonse>(
      DashboardEndpoints.POP_UP,
      { user_id: userId }
    );
  }
}

// Creating an instance of DashboardService and exporting it for use in other parts of the application
export const dashboardService = new DashboardService();
